/**
 * Non-blocking replacement for confirm(): never stops script execution and
 * behaves on mobile. Resolves false on cancel, Escape, or backdrop clicks.
 * The confirm button is always the destructive, non-default action.
 */
export function confirmDialog(message: string, confirmLabel: string): Promise<boolean> {
  return new Promise((resolve) => {
    const dialog = <dialog class="confirm-dialog"></dialog> as HTMLDialogElement;
    const cancel = <button type="button" autofocus>Cancel</button> as HTMLButtonElement;
    const confirm = (
      <button type="button" class="danger-action">{confirmLabel}</button>
    ) as HTMLButtonElement;
    cancel.addEventListener("click", () => dialog.close("cancel"));
    confirm.addEventListener("click", () => dialog.close("confirm"));
    dialog.addEventListener("click", (event) => {
      if (event.target === dialog) dialog.close("cancel");
    });
    dialog.addEventListener("close", () => {
      resolve(dialog.returnValue === "confirm");
      dialog.remove();
    }, { once: true });
    dialog.append(
      <div class="confirm-body">
        <p>{message}</p>
        <div class="confirm-actions">{cancel}{confirm}</div>
      </div>,
    );
    document.body.append(dialog);
    dialog.showModal();
  });
}
